<template>
	<div class="reconciliation_trade">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">BD交易对账</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">对账筛选</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="display: inline-block;margin-right: 40px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;text-align: right;margin-right: 10px;">订单号</span>
								<a-input placeholder="请输入订单号" style="width: 260px" v-model="searchlist.trade_number" />
							</div>
							<div style="display: inline-block;margin-right: 40px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;text-align: right;margin-right: 10px;">订单月份</span>
								<a-month-picker placeholder="Select month" :defaultValue="moment(searchlist.month)" @change="onMonthChange" />
							</div>
							<a-button type="primary" style="width: 96px;" @click="onSearchBD">搜索</a-button>
						</div>
					</div>
					<div class="card-container">
						<a-tabs :defaultActiveKey="searchlist.status" :activeKey="searchlist.status" type="card" :tabBarGutter="5"
						 @change="(activeKey)=>{this.searchlist.status = activeKey;this.selectedRowKeys=[];this.initialize();}">
							<a-tab-pane key="unclear" tab="未结算">
								<div style="display: flow-root;position: relative;margin-bottom: 10px;">
									<a-button type="primary" style="width: 96px;" :disabled="tradelist.length?false:true" @click="exportexcel">导出Excel</a-button>
								</div>
								<a-table :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns"
								 :data-source="tradelist" :pagination="false" />
								<div style="margin-top: 20px;position: relative;" v-if="!issearch">
									<span style="display: inline-block;margin-left: 20px;position: absolute;line-height: 32px;">金额共{{sumprice}}</span>
									<div style="display: block;position: relative;text-align: center;">
										<a-button type="primary" ghost style="width: 96px;" :disabled="selectedRowKeys.length?false:true" @click="balance">结算</a-button>
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane key="clear" tab="已结算">
								<div style="display: flow-root;position: relative;margin-bottom: 10px;">
									<a-button type="primary" style="width: 96px;" :disabled="tradelist.length?false:true" @click="exportexcel">导出Excel</a-button>
								</div>
								<a-table :columns="columns" :data-source="tradelist" :pagination="false" />
							</a-tab-pane>
							<a-tab-pane key="all" tab="全部">
								<div style="display: flow-root;position: relative;margin-bottom: 10px;">
									<a-button type="primary" style="width: 96px;" :disabled="tradelist.length?false:true" @click="exportexcel">导出Excel</a-button>
								</div>
								<a-table :columns="columns" :data-source="tradelist" :pagination="false" />
							</a-tab-pane>
						</a-tabs>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import moment from 'moment';

	const columns = [{
			title: '订单号',
			dataIndex: 'trade_number',
		},
		{
			title: '订单详情',
			dataIndex: 'trade_info',
		},
		{
			title: '金额',
			dataIndex: 'receipt_price_display',
		},
		{
			title: '付款时间',
			dataIndex: 'created_at',
		},
		{
			title: '状态',
			dataIndex: 'is_clear',
		},
	];

	export default {

		data() {
			return {
				current: ['bdreconciliation'],
				openKeys: ['bdmodule'],
				tradelist: [],
				issearch: false,
				id: this.$route.query.id,
				searchlist: {
					trade_number: null,
					month: new Date(),
					status: "unclear",
				},
				columns,
				selectedRowKeys: [],
			}
		},
		created: function() {
			this.initialize();
		},
		computed: {
			sumprice() {
				var all = 0;
				for (var i = 0; i < this.selectedRowKeys.length; i++) {
					all += (this.tradelist[this.selectedRowKeys[i]].receipt_price)
				}
				return "￥" + (all / 100)
			}
		},
		methods: {
			moment,
			initialize() {
				var self = this;
				this.issearch = true;
				this.tradelist = [];
				var params = {
					id: this.id,
					searchlist: JSON.stringify(this.searchlist),
				};
				this.$axios.get('/bd/reconciliation_trade', {
					params: params
				}).then(function(res) {
					var temp_trade = [];
					for (var i = 0; i < res.data.tradelist.UIC_Users.length; i++) {
						for (var j = 0; j < res.data.tradelist.UIC_Users[i].TC_Trades.length; j++) {
							var title = res.data.tradelist.UIC_Users[i].TC_Trades[j].TC_Orders[0].sku_title;
							if (res.data.tradelist.UIC_Users[i].TC_Trades[j].TC_Orders.length > 1) {
								title + "等" + res.data.tradelist.UIC_Users[i].TC_Trades[j].TC_Orders.length + "件商品"
							}
							res.data.tradelist.UIC_Users[i].TC_Trades[j].trade_info = title
							res.data.tradelist.UIC_Users[i].TC_Trades[j].created_at = moment(res.data.tradelist.UIC_Users[i].TC_Trades[j].created_at)
								.format('YYYY-MM-DD HH:mm:ss');
							res.data.tradelist.UIC_Users[i].TC_Trades[j].receipt_price_display = "￥" + (res.data.tradelist.UIC_Users[i].TC_Trades[
								j].receipt_price / 100);
							if (res.data.tradelist.UIC_Users[i].TC_Trades[j].is_clear) {
								res.data.tradelist.UIC_Users[i].TC_Trades[j].is_clear = '已结算'
							} else {
								res.data.tradelist.UIC_Users[i].TC_Trades[j].is_clear = '未结算'
							}
							temp_trade.push(res.data.tradelist.UIC_Users[i].TC_Trades[j])
						}
					}
					for (var i = 0; i < temp_trade.length; i++) {
						temp_trade[i].key = i;
					}
					self.tradelist = temp_trade;
					self.issearch = false;
				});
			},
			onSearchBD() {
				var self = this;
				this.initialize();
			},
			onMonthChange(date, dateString) {
				this.searchlist.month = dateString;
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys;
			},
			balance() {
				var list = [];
				for (var i = 0; i < this.selectedRowKeys.length; i++) {
					list.push(this.tradelist[this.selectedRowKeys[i]].id);
				}
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否结算选中订单',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/bd/cleartrade', {
							params: list
						}).then(function(res) {
							// self.$notification.open({
							// 	message: '通知',
							// 	description: res.data,
							// 	onClose: close,
							// });
							// self.initialize();
							self.$router.push('reconciliationresult')
						})
					},
					onCancel() {},
				});
			},
			exportexcel() {
				var self = this;
				var list = [];
				if (this.selectedRowKeys.length !== 0) {
					for (var i = 0; i < this.selectedRowKeys.length; i++) {
						list.push(this.tradelist[this.selectedRowKeys[i]].id);
					}
				} else {
					for (var i = 0; i < this.tradelist.length; i++) {
						list.push(this.tradelist[i].id);
					}
				}
				var now = this.moment().format('YYYY-MM-DD-HH-mm-ss');
				var params = list;
				this.$axios.post('/export/bdexcel', {
					params: params
				}, {
					responseType: 'arraybuffer'
				}).then(function(res) {
					var fileDownload = require('js-file-download');
					fileDownload(res.data, (now + '.xlsx'));
				})
			},


		}

	};
</script>

<style>
	.reconciliation_trade .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.reconciliation_trade .card-container {
		overflow: hidden;
	}

	.reconciliation_trade .card-container>.ant-tabs-card>.ant-tabs-content {
		min-height: 120px;
		margin-top: -16px;
	}

	.reconciliation_trade .card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
		background: #fff;
		padding: 16px;
	}

	.reconciliation_trade .card-container>.ant-tabs-card>.ant-tabs-bar {
		border-color: #fff;
	}

	.reconciliation_trade .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
		border-color: transparent;
		background: #ebebee;
		width: 90px;
		text-align: center;
	}

	.reconciliation_trade .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
		border-color: #fff;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// index.vue?74034db5